import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig } from '../models/base-api-config.model';

/**
 * Provides API configuration for places related endpoints across the application.
 *
 * The `PlacesApiConfig` is injected via `PLACES_API_CONFIG`
 */

export type PlacesApiConfig = BaseApiConfig<{
  searchPlaces: string; // GET /v1/creator/places/search
}>;

export const PLACES_API_CONFIG = new InjectionToken<PlacesApiConfig>('PLACES_API_CONFIG');

export const providePlacesApiConfig = (config: PlacesApiConfig): StaticProvider => ({
  provide: PLACES_API_CONFIG,
  useValue: config,
});
